import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Loading from "../../../components/Loading";
import { DepositDetails as DepositDetailsView } from "../DepositCard/DepositDetailsModal";
import { Deposit } from "../DepositCard/deposit-dtos";
import { ConnectedDirectOfferDetails } from "../../DirectOfferDetails";
import { NotFound } from "../../NotFound";
import client from "../../../client";

type DepositDetailsProps = { match: { params: { uuid?: string } } };

export const DepositDetails = (props: DepositDetailsProps) => {
  const { t } = useTranslation();
  const uuid = props.match.params.uuid;

  const [deposit, setDeposit] = useState<Deposit | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [offerDeposit, setOfferDeposit] = useState<Deposit | undefined>(undefined);

  useEffect(() => {
    if (!uuid) return;

    setLoading(true);
    setError(null);

    client
      .get(`/api/deposits/${uuid}/`)
      .then(response => {
        setDeposit(response.data);
      })
      .catch(() => {
        setError(t("farmersMarket.depositCard.eventsError"));
      })
      .finally(() => {
        setLoading(false);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [uuid]);

  if (loading) {
    return <Loading isVisible>{t("farmersMarket.depositCard.eventsLoading")}</Loading>;
  }

  if (error || !deposit) {
    return <NotFound />;
  }

  return (
    <>
      <DepositDetailsView
        deposit={deposit}
        onMakeOffer={(d: Deposit) => setOfferDeposit(d)}
        onClickAggregatorDetails={() => {}}
        isOpen={true}
        variant="page"
      />
      <ConnectedDirectOfferDetails
        isOpen={!!offerDeposit}
        onCancel={() => setOfferDeposit(undefined)}
        deposit={offerDeposit}
        redirectPath="/representative/mobile"
      />
    </>
  );
};
